export const MASK_LOADED = "MASK_LOADED";
export const SET_IMAGE_AND_MASK_URL = "SET_IMAGE_AND_MASK_URL";
export const SET_MASK_DATA = "SET_MASK_DATA";
export const RESOLUTION_CHANGED = "RESOLUTION_CHANGED";
